import api from '../api';
import { ContractCategory } from '../../types/compliance';

// NOTE: axios baseURL already ends in `/api/v1`; paths here are relative.
// Edits go through contractPicklists.service (Compliance → Settings).
const BASE = '/compliance/contract-categories';

export const contractCategoriesService = {
  async list(): Promise<ContractCategory[]> {
    const { data } = await api.get<ContractCategory[]>(BASE);
    return data;
  },
};

export default contractCategoriesService;
